import React from 'react';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default function TagHeader() {
  return (
    <div className="d-flex align-items-center gap-2">
      <FontAwesomeIcon icon={faTag} />
      <strong>Tags</strong>
    </div>
  );
}
